export default {
    Badge: {
        baseStyle: {},
        sizes: {},
        variants: {
            tabLabelBadge: {
                bgColor: "secondary.100",
                borderRadius: "full",
                color: "secondary.700",
                fontWeight: "light",
                px: "2",
                py: "0.5"
            }
        },
        defaultProps: {},
    }
};
